<p>Solicitud no. {{claimRequestId}}</p>
<div class="form-group my-3">
  <label>¿Cómo calificas el proceso de solicitud?</label>
  <div class="star-rating mt-2">
    @for (star of stars; track $index; let i = $index) {
      <button
        (click)="selectRating(i + 1)"
        [class.active]="i < selectedRating"
        class="btn star-btn"
        type="button">
        ★
      </button>
    }
  </div>
</div>

<div class="form-group my-3">
  <label for="comment">Comentario</label>
  <textarea
    [(ngModel)]="comment"
    class="form-control"
    id="comment"
    placeholder="Escribe tus comentarios aquí..."
    rows="3">
  </textarea>
</div>

<button (click)="rateClaim()" class="btn btn-outline-dark d-block ms-auto" type="button">Calificar</button>
